const revokedIdentifier = '<REVOKED>'

export const isRevoked = value =>
  value === revokedIdentifier
